module.exports = {
    PDF_LETTER_MODAL_HEIGHT: 5100,
    PDF_LETTER_NORMAL_HEIGHT: 900,
    PDF_LETTER_MODAL_SCALE: 2.0,
    PDF_LETTER_NORMAL_SCALE: 1.05
}
